import { useState } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
} from "@transfr-inc/dashboard-components";
import { LearnerAwardsSlide } from "@components/modals/export-awards/learner-awards-slide.component";
import { handleAwardSelection } from "@components/modals/export-awards/awards.utils";
import { trackCredentialsExported } from "@lib/event-trackers";

export const ExportLearnerAwardsModal = ({
  onClose,
  user,
  open,
  awards,
  courseId,
  classroomId,
}) => {
  const [notification, setNotification] = useState();

  const onAwardSelected = (award) => {
    if (!awards || !award?.groupId) return;
    const link = award.link;
    handleAwardSelection(award, link, setNotification);
    trackCredentialsExported(award.credentialId, user?.userId, classroomId);
  };

  return (
    <Modal open={open} onClose={onClose} modalClassName="export-awards-modal">
      <ModalHeader
        title={"Export Credentials"}
        className="blue-icon"
        icon={["fa-regular", "file-export"]}
      ></ModalHeader>
      <ModalBody>
        <div className="export-awards-modal-content">
          <LearnerAwardsSlide
            awards={awards}
            notification={notification}
            onNotificationClose={() => setNotification()}
            onAwardSelected={onAwardSelected}
            showOpenAllButton={false}
          />
        </div>
      </ModalBody>
    </Modal>
  );
};
